import AdminIdentityVerificationsScreen from '../../src/screens/AdminIdentityVerificationsScreen';

export default function AdminIdentityVerificationsRoute() {
  return <AdminIdentityVerificationsScreen />;
}
